<template>
  <!-- 外層容器：與 RegisterPage 的 3D 效果相同 -->
  <div class="register-container" ref="forgotBlock">
    <nav class="breadcrumb">
    <router-link to="/login">會員登入</router-link> &gt;
    <span>忘記密碼</span>
    </nav>
    <!-- 主要卡片：左右分佈 -->
    <div class="register-card">
      <!-- 左側：品牌介紹 / 步驟指示 -->
      <div class="register-left">
        <h1>忘記密碼</h1>
        <p>只要三步驟，重置新密碼，快速找回您的帳號！</p>

        <!-- 步驟指示器 -->
        <div class="step-indicator">
          <div :class="['step-item', { active: step === 1 }]">
            <span>1</span> 驗證手機
          </div>
          <div :class="['step-item', { active: step === 2 }]">
            <span>2</span> 驗證碼
          </div>
          <div :class="['step-item', { active: step === 3 }]">
            <span>3</span> 設定新密碼
          </div>
        </div>
      </div>

      <!-- 右側：表單容器，多步驟 (step=1/2/3/4) -->
      <div class="register-right form-block">
        <!-- STEP 1：輸入帳號 & 手機，發送驗證碼 -->
        <div class="step-card" v-if="step === 1">
          <h2>步驟 1：輸入手機號碼</h2>

          <div class="tooltip-container">
            <label for="phone">手機電話</label>
            <!-- <small  class="tooltip-text">
                台灣請使用：0912345678<br />
                海外請加區碼：(香港) +852 12345678
              </small > -->
            <input type="text" inputmode="numeric" id="phone" v-model="phone" placeholder="0912345678" />
          </div>
          <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>

          <button type="button" @click="sendVerificationCode">發送驗證碼</button>
        </div>

        <!-- STEP 2：輸入驗證碼 -->
        <div class="step-card" v-else-if="step === 2">
          <h2>步驟 2：輸入驗證碼</h2>

          <label for="verificationCode">驗證碼</label>
          <input inputmode="numeric" id="verificationCode" type="text"  maxlength="6" name="no-autofill" v-model="verificationCode" placeholder="請輸入手機驗證碼" />
          <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>

          <button type="button" @click="verifyCode">確認驗證碼</button>
        </div>

        <!-- STEP 3：重設新密碼 -->
        <div class="step-card" v-else-if="step === 3">
          <h2>步驟 3：設定新密碼</h2>

          <div class="form-group">
            <label for="newPassword">新密碼</label>
            <input id="newPassword" type="password" v-model="newPassword" placeholder="請輸入新密碼" />
          </div>
          <div class="form-group">
            <label for="confirmPassword">再次輸入新密碼</label>
            <input id="confirmPassword" type="password" v-model="confirmPassword" placeholder="再輸入一次" />
          </div>

          <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
          <button type="button" :disabled="!isUpdateEnabled()" @click="resetPassword">重設密碼</button>
        </div>

        <!-- STEP 4：顯示成功 & 導回登入 -->
        <div class="step-card" v-else-if="step === 4">
          <h2>密碼重置成功</h2>
          <p>您的新密碼已更新，現在可以使用新密碼登入帳號。</p>
          <button type="button" @click="goLogin">返回登入頁</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ForgotPassword",
  data() {
    return {
      step: 1,              // 控制目前步驟 (1, 2, 3, 4)
      phone: "",            // 手機
      verificationCode: "", // 驗證碼
      newPassword: "",      // 新密碼
      confirmPassword: "",  // 確認密碼
      errorMessage: ""      // 錯誤訊息顯示
    };
  },
  watch: {
    newPassword: 'updateVerificationMessage',
    confirmPassword: 'updateVerificationMessage'
  },
  methods: {
    updateVerificationMessage() {
      if (this.newPassword.length === 0) {
        this.errorMessage = "密碼不能為空";
      } else if (!/^(?=.*[a-z])(?=.*\d).{6,}$/.test(this.newPassword)) {
        this.errorMessage = "新密碼必須至少6位且包含一個小寫字母和一個數字";
      } else if (this.newPassword !== this.confirmPassword) {
        this.errorMessage = "密碼與確認密碼不匹配";
      } else {
        this.errorMessage = '';  // 清空消息，表示無錯誤
      }
    },
    isUpdateEnabled() {
      if (this.newPassword.length === 0) {
        return false;
      } else if (this.newPassword !== this.confirmPassword) {
        return false;
      } else if (!/^(?=.*[a-z])(?=.*\d).{6,}$/.test(this.newPassword)) {
        return false;
      }
      return true;
    },
    // STEP 1：發送驗證碼
    async sendVerificationCode() {
      if (!this.phone) {
        this.errorMessage = "請輸入手機號碼。";
        return;
      }
      try {
        const res = await axios.post("/api/phone/forgot-sendcode", {
          phone: this.phone
        });
        if (res.data.success) {
          this.errorMessage = "";
          this.step = 2;
        } else {
          this.errorMessage = res.data.message || "發送驗證碼失敗";
        }
      } catch (error) {
        this.errorMessage =
          error.response?.data?.message || "伺服器錯誤，請稍後再試";
      }
    },

    // STEP 2：驗證驗證碼
    async verifyCode() {
      if (!this.verificationCode) {
        this.errorMessage = "請輸入驗證碼。";
        return;
      }
      try {
        const res = await axios.post("/api/phone/verifycode", {
          type: "forgot",
          phone: this.phone,
          code: this.verificationCode
        });
        if (res.data.success) {
          this.errorMessage = "";
          this.step = 3;
        } else {
          this.errorMessage =
            res.data.message || "驗證失敗，驗證碼錯誤或已過期";
        }
      } catch (error) {
        this.errorMessage =
          error.response?.data?.message || "伺服器錯誤，請稍後再試";
      }
    },

    // STEP 3：重設新密碼
    async resetPassword() {
      if (!this.newPassword || !this.confirmPassword) {
        this.errorMessage = "請輸入新密碼並確認。";
        return;
      }
      if (this.newPassword !== this.confirmPassword) {
        this.errorMessage = "兩次輸入的密碼不相符。";
        return;
      }
      try {
        const res = await axios.post("/api/user/resetPassword", {
          phone: this.phone,
          newPassword: this.newPassword
        });
        if (res.data.success) {
          this.errorMessage = "";
          this.step = 4; // 進入成功畫面
        } else {
          this.errorMessage = res.data.message || "重設失敗。";
        }
      } catch (error) {
        this.errorMessage =
          error.response?.data?.message || "伺服器錯誤，請稍後再試";
      }
    },
    // STEP 4：返回登入
    goLogin() {
      this.$router.push("/login");
    }
  },
  mounted() {
    // IntersectionObserver：3D 翻轉 & 淡入動畫
    const container = this.$refs.forgotBlock;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("container-visible");
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(container);
  }
};
</script>

<style scoped>
/* 與 RegisterPage 相同外觀 */

/* 最外層容器 */
.register-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  opacity: 0;
  transform: translateY(50px) rotateX(8deg);
  transform-origin: top;
  transition: opacity 1.2s ease, transform 1.2s ease;
  perspective: 800px;
  /* 3D視角 */
}

.register-container.container-visible {
  opacity: 1;
  transform: translateY(0) rotateX(0);
}

/* 大卡片 */
.register-card {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 30px;

  background-color: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
  padding: 30px;

  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.container-visible .register-card {
  opacity: 1;
  transform: translateY(0);
}

/* 左 / 右 */
.register-left,
.register-right {
  flex: 1;
  min-width: 300px;
}

/* 左側：品牌說明 + 步驟指示器 */
.register-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.register-left h1 {
  margin-bottom: 10px;
}

.register-left p {
  line-height: 1.6;
}

/* 步驟指示器 */
.step-indicator {
  display: flex;
  margin: 15px 0;
}

.step-item {
  display: flex;
  align-items: center;
  margin-right: 10px;
  color: #999;
}

.step-item span {
  background-color: #999;
  color: #fff;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}

.step-item.active {
  color: #007bff;
}

.step-item.active span {
  background-color: #007bff;
}

/* 右側表單區 */
.register-right {
  display: flex;
  flex-direction: column;
}

/* 表單外層容器：限制寬度 + 置中 (類似 .form-block) */
.form-block {
  max-width: 400px;
  margin: 0 auto;
  text-align: left;
}

.form-block input,
.form-block select,
.form-block textarea {
  width: 100%;
  box-sizing: border-box;
  /* 避免 padding 撐大 */
  /* 其他 styling, 如 padding, border, font-size */
}


/* 各步驟卡片 */
.step-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  text-align: left;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/* input */
label {
  display: block;
  margin-top: 15px;
  font-weight: bold;
}

input {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

/* 按鈕 */
button {
  display: inline-block;
  margin-top: 15px;
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}

/* 錯誤訊息 */
.error-message {
  color: red;
  margin-top: 10px;
  font-size: 14px;
}

/* Tooltip (跟 RegisterPage / ContactPage 相同) */
.tooltip-container {
  position: relative;
  margin-bottom: 15px;
}

.tooltip-text {
  visibility: hidden;
  width: 300px;
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 8px;
  border-radius: 4px;
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip-container:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
/* 響應式：手機板上下堆疊 */
@media (max-width: 768px) {
  .register-card {
    flex-direction: column;
  }
}
/* 文字 */
/* @media (max-width: 768px) {
  .register-card {
    flex-direction: column;
  }
  h1 {
    font-size: 2.0rem;
  }
  h2 {
    font-size: 1.8rem;
  }
  h3 {
    font-size: 1.5rem;
  }
  .step-indicator{
    font-size: 1.05rem;
  }
  label{
    font-size: 1.5rem;
  }
  input{
    font-size: 1.5rem;
  }
  button{
    font-size: 1.5rem;
  }
  .error-message{
    font-size: 1.25rem;
  }
} */
</style>